import gql from 'graphql-tag';

export const GET_RECORDS_LPR = gql`
  {
    getRecordsLpr {
      id
      mall
      begin_datetime
      finish_datetime
      interval
      plate
      type
    }
  }
`;

export const GET_REJECTED_LPR = gql`
  {
    getRejectedLpr {
      id
      mall
      begin_datetime
      finish_datetime
      interval
      plate
      type
    }
  }
`;

export const GET_BLACKLIST = gql`
  query RegistersBlackList(
    $begin_datetime: String
    $finish_datetime: String
    $plate: String
    $mall_id: ID
    $active: Boolean
    $motives_id: ID
  ) {
    getBlacklist(
      license_plate: $plate
      mall_id: $mall_id
      date_ini: $begin_datetime
      date_end: $finish_datetime
      active: $active
      motives_id: $motives_id
    ) {
      id
      country_id
      country_name
      mall_id
      mall_name
      license_plate
      motive
      motives_id
      description
      date_ini
      date_end
      active
    }

    getMalls {
      id
      name
      code
      country_id
      country_name
    }

    getMotives(active: true) {
      id
      motive
    }
  }
`;

export const GET_ALL_RECORDS = gql`
  query GetAllRecords(
    $begin_datetime: String
    $finish_datetime: String
    $plate: String
    $mall_id: ID
    $type: String
  ) {
    getAllRecords(
      begin_datetime: $begin_datetime
      finish_datetime: $finish_datetime
      plate: $plate
      mall_id: $mall_id
      type: $type
    ) {
      excluded {
        id
        mall
        mall_code
        mall_id
        datetime
        license_plate
        type
        type_name
        camera_name
        camera_lpr_cat_id
        mall_access_name
      }
      notExcluded {
        id
        mall
        mall_code
        mall_id
        datetime
        license_plate
        type
        type_name
        camera_name
        camera_lpr_cat_id
        mall_access_name
      }
      lprBlacklist {
        id
        mall
        mall_code
        mall_id
        datetime
        license_plate
        type
        type_name
        camera_name
        camera_lpr_cat_id
        mall_access_name
      }
    }

    getMalls {
      id
      code
      name
    }
  }
`;

export const GET_MALLS_BY_NAME = gql`
  {
    getMalls {
      id
      code
      name
    }
    getCountries {
      id
      name
    }
  }
`;

export const GET_MALLS = gql`
  {
    getMalls {
      id
      name
      code
      country_id
      country_name
      lat
      lon
      address
      active
    }

    getCountries {
      id
      name
    }
  }
`;

export const GET_MALL_ACCESS = gql`
  {
    getMalls {
      id
      name
      code
      country_id
      country_name
    }
    getMallAccess {
      id
      code
      name
      mall_id
      mall_name
      country_name
      lat
      lon
      address
      active
    }
  }
`;

export const GET_CAMERAS = gql`
  query GetCameras($mall_id: ID, $active: Boolean) {
    getCameras(mall_id: $mall_id, active: $active) {
      id
      mall_acc_id
      mall_acc_code
      mall_acc_name
      mall_id
      mall_name
      lane
      lpr_id
      lpr_cat_id
      lpr_config_name
      direction
      last_update
      active
    }
    getMallAccess {
      id
      code
      name
      mall_code
    }
    getLprConfig {
      id
      name
    }
    getMalls {
      id
      name
      code
      country_id
      country_name
    }
  }
`;

export const GET_SERVICES_CONFIG = gql`
  {
    getLprConfig {
      id
      name
      description
      exec_seconds
      exec_time
      last_exec_time
      one_time_day
      login
      password
      ipv4_address
      port
      active
    }
  }
`;

export const GET_MOTIVES = gql`
  {
    getMotives {
      id
      motive
      creation_date
      active
    }
  }
`;

export const GET_TELEGRAM_GROUPS = gql`
  {
    getTelegramGroups {
      id
      group_id
      group_name
      mall_name
      mall_id
      active
    }
    getMalls {
      id
      name
      code
      country_id
      country_name
    }
  }
`;

export const GET_EXCLUSION_RULES = gql`
  {
    getExclusionRules {
      id
      country_id
      country
      mall_id
      mall
      rule
      rule_type
      creation_date
      active
    }

    getCountries {
      id
      name
    }

    getMalls {
      id
      name
      code
    }
  }
`;
